import { render, staticRenderFns } from "./InstrumentPrice.vue?vue&type=template&id=36694fb0&scoped=true&"
import script from "./InstrumentPrice.vue?vue&type=script&lang=ts&"
export * from "./InstrumentPrice.vue?vue&type=script&lang=ts&"
import style0 from "./InstrumentPrice.vue?vue&type=style&index=0&id=36694fb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36694fb0",
  null
  
)

export default component.exports